module.exports = __webpack_public_path__ + "static/media/leadership-edition-2024-social-image.49d61f64.jpg";